import { makeStyles } from "@material-ui/core";
import React from "react";
import { Footer } from "v2/components/footer";
import { Header } from "v2/components/hearder";
import LogoTrustAuto from "v2/components/logo";
import { CustomDialog } from "views/dialog";

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
  },
  center: {
    display: "flex",
    justifyContent: "center",
    "@media only screen and (max-width: 1280px)": {
      flexDirection: "column",
    },
  },
  item: {
    background: "rgba(196, 196, 196, 0.14)",
    padding: 20,
    margin: 20,
    width: "40%",
    borderRadius: 15,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    "@media only screen and (max-width: 1280px)": {
      marginLeft: "auto",
      marginRight: "auto",
      width: "100%",
    },
  },
  itemcarousel: {
    padding: 0,
    margin: 20,
    width: "100%",
    marginTop: "auto",
    marginBottom: "auto",
    "@media only screen and (max-width: 1280px)": {
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  title: {
    fontWeight: 600,
    paddingLeft: 18,
    color: "#3c4858",
    marginBottom: 50,
    display: "flex",
    justifyContent: "center",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    border: "rgba(196, 196, 196, 0.14)",
  },
  field: {
    padding: 16,
    width: "100%",
    fontWeight: 600,
    fontSize: 16,
    height: 50,
    border: "rgba(196, 196, 196, 0.14)",
    background: "white",
    "&>*": {
      border: "rgba(196, 196, 196, 0.14)",
    },
    "&>.MuiInput-root": {
      fontWeight: 600,
      fontSize: 16,
    },
  },
  divInput: {
    padding: 16,
    display: "flex",
    justifyContent: "space-between",
  },
  divInputError: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  btn: {
    padding: 16,
    width: "100%",
    fontWeight: 700,
    fontSize: 14,
    border: "rgba(196, 196, 196, 0.14)",
    background: "#C4C4C4",
    cursor: "pointer",
  },
  logo: {
    marginRight: "auto",
    marginLeft: "auto",
    display: "flex",
    flexDirection: "center",
  },
  price: {
    color: "#111",
    marginLeft: 10,
  },
  dialogRoot: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    "&>div": {
      margin: 20,
      padding: 16,
      display: "flex",
      justifyContent: "center",
    },
  },
  continueBtn: {
    background: "#DDBB78",
    width: "100%",
    height: 60,
    border: "#DDBB78",
    fontWeight: 700,
    fontSize: 16,
    paddingLeft: 16,
    paddingRight: 16,
    cursor: "pointer",
  },
  tkxBtn: {
    fontSize: 16,
    marginLeft: "auto",
    marginRight: "auto",
    textAlgin: "center",
    height: 60,
    border: "#FFF",
    background: "transparent",
    cursor: "pointer",
  },
  msg: {
    fontSize: 16,
    marginLeft: "auto",
    marginRight: "auto",
    padding: 16,
    textAlgin: "center",
  },
  error: {
    color: "#f50d0d",
  },
}));

const url = "https://shielded-oasis-59520.herokuapp.com/";
const contactForm = {
  name: "",
  email: "",
  phone: "",
  body: "",
};

export function Contact(props) {
  const styles = useStyles();
  const [form, setForm] = React.useState(contactForm);
  const [openDialog, setOpenDialog] = React.useState(false);
  const { name, email, phone, body } = form;

  const handlerForm = React.useCallback((e) => {
    e.preventDefault();

    setOpenDialog(true);
  });
  const onChangeForm = React.useCallback((e) => {
    e.preventDefault();
    e.persist();
    setForm({ ...form, [e.target.name]: e.target.value });
  });

  const onCloseDialgo = React.useCallback(() => {
    props.history.push("/");
    setOpenDialog(false);
  });

  const phoneError = React.useMemo(
    () =>
      phone.match(/^((\+|00)(221))?[7|3|8]{1}[0|7|5|0|6|8]{1}[0-9]{7}/g) != null
  );

  return (
    <div className={styles.root}>
      <Header />
      <div className={styles.center}>
        <div className={styles.item}>
          <div className={styles.logo}>
            <LogoTrustAuto />
          </div>
          <div>
            <h3 className={styles.title}>Nous Laisser Un Message</h3>
          </div>

          <div>
            <form className={styles.form} method="post" onSubmit={handlerForm}>
              <div className={styles.divInput}>
                <input
                  placeholder="Nom"
                  minLength="2"
                  required
                  className={styles.field}
                  value={name}
                  name="name"
                  onChange={onChangeForm}
                />
              </div>

              <div className={styles.divInput}>
                <div className={styles.divInputError}>
                  <input
                    placeholder="Votre Téléphone"
                    className={styles.field}
                    type="tel"
                    value={phone}
                    name="phone"
                    onChange={onChangeForm}
                    required
                    pattern="^((\+|00)(221))?[7|3|8]{1}[0|7|5|0|6|8]{1}[0-9]{7}"
                  />
                  {!phoneError && (
                    <span className={styles.error}>eg: 77 777 11 12</span>
                  )}
                </div>
                <input
                  style={{
                    marginLeft: 10,
                  }}
                  placeholder="Votre Email"
                  className={styles.field}
                  type="email"
                  value={email}
                  name="email"
                  onChange={onChangeForm}
                  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                  required
                />
              </div>

              <div className={styles.divInput}>
                <textarea
                  cols="50"
                  placeholder="Votre Message Ici"
                  className={styles.field}
                  type="text"
                  value={body}
                  name="body"
                  onChange={onChangeForm}
                  required
                />
              </div>

              <div className={styles.divInput}>
                <button className={styles.btn} type="submit">
                  Envoyer
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
      <CustomDialog onClose={onCloseDialgo} onOpen={openDialog}>
        <div className={styles.dialogRoot}>
          <div className={styles.msg}>
            Merci de prendre contact, Nous manquerons pas de vous revenir trés
            prochainement.
          </div>
          <div>
            <button className={styles.tkxBtn} onClick={onCloseDialgo}>
              Fermer
            </button>
          </div>
        </div>
      </CustomDialog>
    </div>
  );
}

export default Contact;
